import { render, staticRenderFns } from "./ClinicPhyDic.vue?vue&type=template&id=343a70fa"
import script from "./ClinicPhyDic.vue?vue&type=script&lang=js"
export * from "./ClinicPhyDic.vue?vue&type=script&lang=js"
import style0 from "./ClinicPhyDic.vue?vue&type=style&index=0&id=343a70fa&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343a70fa')) {
      api.createRecord('343a70fa', component.options)
    } else {
      api.reload('343a70fa', component.options)
    }
    module.hot.accept("./ClinicPhyDic.vue?vue&type=template&id=343a70fa", function () {
      api.rerender('343a70fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/dictionary/ClinicPhyDic.vue"
export default component.exports